module.exports = __webpack_public_path__ + "static/media/banner4.a7c1b26f.png";